/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Activity_SubtitleInputs */



/**
* | output |
* | --- |
* | "Recent plan and add-on changes across all partner customers." |
*
* @param {Partner_Admin_Activity_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_activity_subtitle = /** @type {((inputs?: Partner_Admin_Activity_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Activity_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Tarif- und Add-on-Änderungen aller Partnerkunden.")
	return /** @type {LocalizedString} */ ("Recent plan and add-on changes across all partner customers.")
});